import { BlankLayout } from "@/layout";
import {
  protocolRoute,
  disclaimerRoute,
  agreementRoute,
} from "@/config/RouteConfig";

const publicRoute = {
  path: "/public",
  component: BlankLayout,
  children: [
    {
      ...protocolRoute,
      component: () => import("@/views/public/protocol"),
    },
    {
      ...disclaimerRoute,
      component: () => import("@/views/public/disclaimer.vue"),
    },
    {
      ...agreementRoute,
      component: () => import("@/views/public/agreement.vue"),
    },
  ],
};

export default publicRoute;
